module.exports = __webpack_public_path__ + "img/anonymous-person-m.ee435b8.png";